import { jsxs as x, jsx as u } from "react/jsx-runtime";
import { u as d } from "./index-6a632112.mjs";
import { f as w, e as l, a as r, s as n, r as g, c as S, b as T } from "./themes-5f0b3c3d.mjs";
import { l as o } from "./lineHeights-72d3110c.mjs";
import "react";
import { useAccessibilityProps as P } from "./accessibility.js";
const A = d.a`
  display: ${(e) => e.$variant === "onImage" ? "inline-flex" : "inline-block"};
  align-items: center;
  font-family: ${w.inter};
  color: ${(e) => e.$variant === "onImage" ? e.theme.components.link.onImageTextColor : e.theme.components.link.textColor};
  font-style: normal;
  font-weight: ${(e) => e.size === "xsmall" && l.medium.XS.fontWeight || e.size === "small" && l.medium.S.fontWeight || e.size === "medium" && l.medium.M.fontWeight || e.size === "large" && l.medium.L.fontWeight};
  font-size: ${(e) => e.size === "medium" ? r.small : e.size === "large" ? r.medium : e.size === "xsmall" ? r.xxsmall : r.xsmall};
  line-height: ${(e) => e.size === "medium" ? o.medium : e.size === "large" ? o.large : e.size === "xsmall" ? o.xsmall : o.small};
  &:link {
    color: ${(e) => e.disabled ? e.theme.components.link.disabledColor : e.$variant === "onImage" ? e.theme.components.link.onImageTextColor : e.theme.components.link.textColor};
    pointer-events: ${(e) => {
  if (e.disabled)
    return "none";
}};
    text-decoration: none;
  }
  &:visited {
    color: ${(e) => e.disabled ? e.theme.components.link.disabledColor : e.$variant === "onImage" ? e.theme.components.link.onImageVisitedColor : e.theme.components.link.visitedColor};
    text-decoration: none;
  }
  &:hover {
    color: ${(e) => e.$variant === "onImage" ? e.theme.components.link.onImageHoverColor : e.theme.components.link.hoverColor};
    text-decoration: ${(e) => e.$variant === "onImage" ? "none" : "underline"};
    text-decoration-color: ${(e) => e.theme.components.link.hoverColor};
    text-underline-offset: ${(e) => e.size === "small" ? n["1x"] : "5px"};
  }
  &:active {
    color: ${(e) => e.disabled ? e.theme.components.link.disabledColor : e.theme.components.link.activeColor};
    text-decoration: underline;
    text-decoration-color: ${(e) => e.theme.components.link.activeColor};
    text-underline-offset: ${(e) => e.size === "small" ? n["1x"] : "5px"};
  }
  &:disabled {
    color: ${(e) => {
  if (e.disabled)
    return e.theme.components.link.disabledColor;
}};
    cursor: not-allowed;
    text-decoration: none;
  }
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: 2px solid ${(e) => e.theme.components.link.borderColor};
    border-radius: ${g["2x"]};
    outline-offset: ${n["1x"]};
  }
`, j = d.span`
  display: inline-block;
  align-items: center;
  font-family: Inter;
  color: ${S.brandTwilight[500]};
  font-style: normal;
  font-weight: ${(e) => e.size === "xsmall" && l.medium.XS.fontWeight || e.size === "small" && l.medium.S.fontWeight || e.size === "medium" && l.medium.M.fontWeight || e.size === "large" && l.medium.L.fontWeight};
  font-size: ${(e) => e.size === "medium" ? r.small : e.size === "large" ? r.medium : e.size === "xsmall" ? r.xxsmall : r.xsmall};
  line-height: ${(e) => e.size === "medium" ? o.medium : e.size === "large" ? o.large : e.size === "xsmall" ? o.xsmall : o.small};
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: ${T["2x"]} solid
      ${(e) => e.theme.components.link.borderColor};
    border-radius: ${g["2x"]};
    outline-offset: ${n["1x"]};
  }
`, h = d.div`
  display: inline;
  padding-right: ${n["1x"]};

  svg,
  img {
    margin-bottom: -2px;
    width: ${(e) => e.size === "small" || e.size === "xsmall" ? n["4x"] : n["5x"]};
    height: ${(e) => e.size === "small" || e.size === "xsmall" ? n["4x"] : n["5x"]};
  }
`, $ = d.div`
  display: inline;
  top: 2px;
  position: relative;
  padding-left: ${n["1x"]};
  svg,
  img {
    width: ${(e) => e.size === "small" || e.size === "xsmall" ? n["4x"] : n["5x"]};
    height: ${(e) => e.size === "small" || e.size === "xsmall" ? n["4x"] : n["5x"]};
  }
`;
function H(e) {
  const s = (i) => i?.startsWith("http"), t = (i) => i?.startsWith("/") || i?.startsWith("./") || i?.startsWith("../");
  return s(e) ? !1 : (t(e), !0);
}
const F = ({
  size: e = "small",
  children: s,
  to: t,
  target: i,
  rel: k,
  disabled: f = !1,
  isCurrentPage: b = !1,
  leadingIcon: m,
  trailingIcon: a,
  variant: z = "default",
  onClick: v,
  as: C,
  isDisclosureLink: W = !1,
  accessibilityOption: y
}) => {
  const I = P(t ? "link" : "button", {
    ...y,
    ariaDisabled: f
  }), c = H(t);
  t && !c ? i = i || "_blank" : t && (i = i || "_self");
  const L = c && {
    as: C,
    target: i,
    to: t
  };
  return b ? /* @__PURE__ */ x(j, { size: e, children: [
    m && /* @__PURE__ */ u(h, { size: e, children: m }),
    s,
    a && /* @__PURE__ */ u($, { size: e, children: a })
  ] }) : /* @__PURE__ */ x(
    A,
    {
      href: t,
      target: i,
      rel: k,
      size: e,
      disabled: f,
      tabIndex: f ? -1 : 0,
      $variant: z,
      onClick: v,
      className: W ? "disclosure-superscript-link" : null,
      ...c && L,
      ...I,
      children: [
        m && /* @__PURE__ */ u(h, { size: e, children: m }),
        s,
        a && /* @__PURE__ */ u($, { size: e, children: a })
      ]
    }
  );
};
export {
  F as Link
};
